var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, EventEmitter } from '@angular/core';
import { FileUpload } from './file-upload';
// Abstract Class
var FormPage = /** @class */ (function (_super) {
    __extends(FormPage, _super);
    function FormPage(details, userApi, storageApi, eventsManager) {
        var _this = _super.call(this, userApi, storageApi, eventsManager) || this;
        _this.valid = true;
        _this.saved = true;
        _this.next = new EventEmitter();
        _this.back = new EventEmitter();
        _this.details = details;
        return _this;
    }
    /* {
       
      // Make sure form is in good order to be sent to back end
      // e.g. date, if need to convert name to id, etc.
    
      // return a promise for the api call
      e.g.
      let that = this;
      return new Promise(function(resolve, reject) {
        that.userApi.getDetails(that.id).subscribe(
          (savedDraft: PayeeDetail) => {
            that.userApi.updateDetails(that.id, that.details).subscribe(
              res => {
                that.saved = true;
                if (!submit) {
                  that.eventsManager.savedPopUp();
                }
                resolve(res);
              },
              err => reject(err)
            );
          },
          err => {
            that.userApi.createDetails(that.id, that.details).subscribe(
              res => {
                that.saved = true;
                if (!submit) {
                  that.eventsManager.savedPopUp();
                }
                resolve(res);
              },
              err => reject(err)
            );
          }
        );
      });
    } */
    FormPage.prototype.scrollToError = function () {
        // let elements = document.getElementsByClassName('msg-error') as HTMLCollectionOf<HTMLObjectElement>;
        // console.log("FormPageComponent - validate: elements");
        // console.log(elements);
        // this.valid = elements.length <= 0;
        // if (elements.length > 0) {
        //   setTimeout(function() {
        //     for(var i = 0; i < elements.length; i++){
        //       console.log(i);
        //       console.log(elements[i].offsetHeight);
        //       if (elements[i].offsetParent != null) {
        //         console.log(i);
        //         elements[i].scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
        //       }
        //     }
        //   }, 
        //   1000);
        // }
    };
    FormPage.prototype.notSaved = function () {
        if (!this.valid) {
            this.validate();
        }
        this.saved = false;
    };
    // Navigation
    FormPage.prototype.nextPage = function () {
        if (this.saved) {
            this.scrollToTop();
            this.next.emit('next');
        }
        else {
            // this.eventsManager.notSavedPopUp();
            if (!this.eventsManager.submitted) {
                this.save(false);
            }
            this.next.emit('next');
        }
    };
    FormPage.prototype.prevPage = function () {
        if (this.saved) {
            this.scrollToTop();
            this.back.emit('back');
        }
        else {
            // this.eventsManager.notSavedPopUp();
            if (!this.eventsManager.submitted) {
                this.save(false);
            }
            this.back.emit('back');
        }
    };
    return FormPage;
}(FileUpload));
export { FormPage };
